import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface KontrollIndikator {
  id: string;
  gebaeude_id: string;
  gebaeude_name: string;
  sektion_id: string;
  sektion_name: string;
  room_id: string;
  room_name: string;
  indikator_id: string;
  indikator_name: string;
  wert?: number;
  befall?: number;
  befall_status_id?: number;
  problem?: string;
  massnahme?: string;
  checked?: string;
  checked_by?: string;
  anmerkung?: string;
  interne_notiz?: string;
  kontrolltermin_id: string;
  created_at?: string;
  updated_at?: string;
}

@Injectable({
  providedIn: 'root'
})
export class KontrollIndikatorService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getKontrollIndikatoren(params?: any): Observable<any> {
    return this.http.get(`${this.apiUrl}/kontroll-indikator`, { params });
  }

  getKontrollIndikator(id: string): Observable<KontrollIndikator> {
    return this.http.get<KontrollIndikator>(`${this.apiUrl}/kontroll-indikator/${id}`);
  }

  getByKontrolltermin(kontrollterminId: string): Observable<KontrollIndikator[]> {
    return this.http.get<KontrollIndikator[]>(`${this.apiUrl}/kontroll-indikator/kontrolltermin/${kontrollterminId}`);
  }

  createKontrollIndikator(data: Partial<KontrollIndikator>): Observable<KontrollIndikator> {
    return this.http.post<KontrollIndikator>(`${this.apiUrl}/kontroll-indikator`, data);
  }

  updateKontrollIndikator(id: string, data: Partial<KontrollIndikator>): Observable<KontrollIndikator> {
    return this.http.put<KontrollIndikator>(`${this.apiUrl}/kontroll-indikator/${id}`, data);
  }

  deleteKontrollIndikator(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/kontroll-indikator/${id}`);
  }

  bulkCreate(data: Partial<KontrollIndikator>[]): Observable<any> {
    return this.http.post(`${this.apiUrl}/kontroll-indikator/bulk`, data);
  }

  getStats(): Observable<any> {
    return this.http.get(`${this.apiUrl}/kontroll-indikator-stats`);
  }

  bulkUpdateChecked(kontrollterminId: string, checkedDate?: string, checkedBy?: number | string): Observable<any> {
    const payload: any = {
      kontrolltermin_id: kontrollterminId
    };
    if (checkedDate) {
      payload.checked_date = checkedDate; // Format: YYYY-MM-DD
    }
    if (checkedBy !== undefined && checkedBy !== null) {
      payload.checked_by = checkedBy;
    }
    return this.http.put(`${this.apiUrl}/kontroll-indikator/bulk-update-checked`, payload);
  }
}
